import Api from 'requestapijs';
import { BehaviorSubject } from 'rxjs';
import { API_URL, HEADER } from '../config';
import { CompanyService } from './CompanyService';
import {
  ExpenseEdges,
  ExpenseQueryResponse,
  ExpenseQuery,
  ExpenseQueryVariable,
  AddExpenseVariables,
  ExpenseMutation,
  ExpenseNode,
} from '../components/master/Expense/constants';
import {
  AddExpenseEntryVariable,
  ExpenseEntryMutation,
  ExpenseEntryFormData,
  ExpenseEntryNodeEdge,
  SetDefaultExpenseEntryMutation,
  ExpenseEntryDetailInput,
} from '../components/ExpenseEntry/constants';

export class ExpenseService {
  static instance: ExpenseService;
  constructor() {
    if (ExpenseService.instance) {
      return ExpenseService.instance;
    } else {
      ExpenseService.instance = this;
    }
    this.onInit();
  }

  public readonly expense$ = new BehaviorSubject<ExpenseEdges[]>([]);
  private readonly token = localStorage.getItem('token');
  compnayService = new CompanyService();

  onInit() {
    this.compnayService?.company$.subscribe(
      (company) => company?.id && this.getAll(company.id),
    );
  }

  getAll(companyId: string) {
    Api.graphql<ExpenseQueryVariable, ExpenseQueryResponse>(
      API_URL,
      { companyId },
      ExpenseQuery,
      HEADER,
      (response) => this.expense$.next(response.data.allExpenses.edges),
      (error) => error,
    );
  }

  addExpense(
    data: ExpenseNode,
    onSuccess?: (response) => void,
    onError?: (error) => void,
  ) {
    delete data.company;
    Api.graphql<AddExpenseVariables, {}>(
      API_URL,
      {
        input: {
          expense: {
            ...data,
            companyId: this.compnayService?.company$.value?.id,
          },
        },
      },
      ExpenseMutation,
      HEADER,
      (response) => {
        this.onInit();
        onSuccess && onSuccess(response);
      },
      (error) => onError && onError(error),
    );
  }

  addExpenseEntry(
    data: ExpenseEntryFormData<ExpenseEntryDetailInput[]>,
    onSuccess: (reponse) => void,
    onError: (response) => void,
  ) {
    delete data.company;
    delete data.branch;
    data.expenseDetails = data.expenseDetails.map((dpd) => {
      dpd.date = data.date;
      dpd.companyId = this.compnayService?.company$.value?.id;
      return dpd;
    });

    Api.graphql<AddExpenseEntryVariable, {}>(
      API_URL,
      {
        input: {
          expenseEntry: data,
        },
      },
      ExpenseEntryMutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      onError,
    );
  }

  addDefaultExpenseEntry(
    amount: number,
    onSuccess: () => void,
    onError: () => void,
  ) {
    Api.graphql<
      {
        input: {
          value: { companyId?: string; branchId?: string; amount: number };
        };
      },
      {}
    >(
      API_URL,
      {
        input: {
          value: {
            amount,
            companyId: this.compnayService?.company$.value?.id,
            branchId: this.compnayService?.selectedBussiness$.value?.id,
          },
        },
      },
      SetDefaultExpenseEntryMutation,
      HEADER,
      () => {
        onSuccess();
      },
      onError,
    );
  }
}
